export default __webpack_public_path__ + "8ac6d3d99ab87e5c06d9298b5c57e022.png";